(function () {
  var videoPlayers = document.querySelectorAll('.file-video');

  if (videoPlayers && videoPlayers.length > 0) {

    Array.prototype.slice.call(videoPlayers)
      .forEach(function (videoPlayer) {
        initializeVideoFileControls(videoPlayer);
      });
  }
})();